import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

const QuoteRequestPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    companyName: '',
    contactName: '',
    email: '',
    phone: '',
    projectType: '',
    projectDescription: '',
    budget: '',
    timeline: '',
  });
  const [files, setFiles] = useState<File[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFiles(Array.from(e.target.files));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));

    setIsSubmitting(false);
    navigate('/quote-success');
  };

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-r from-[#0D47A1] to-[#1976D2] text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">طلب عرض سعر للمشاريع الكبرى</h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            نقدم حلولاً متكاملة للمشاريع الكبرى من التصميم إلى التنفيذ والصيانة. املأ النموذج وسيتواصل معك فريقنا خلال 24 ساعة
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Form */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">معلومات المشروع</h2>
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      اسم الشركة <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                      placeholder="اسم شركتك"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      اسم المسؤول <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="contactName"
                      value={formData.contactName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                      placeholder="الاسم الكامل"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      البريد الإلكتروني <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                      placeholder="example@company.com"
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">
                      رقم الجوال <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1]"
                      placeholder="05xxxxxxxx"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    نوع المشروع <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="projectType"
                    value={formData.projectType}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 pr-8 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1] cursor-pointer"
                  >
                    <option value="">اختر نوع المشروع</option>
                    <option value="supermarket">تجهيز سوبرماركت</option>
                    <option value="warehouse">مشروع مستودعات</option>
                    <option value="cooling">مشروع تبريد</option>
                    <option value="residential">مشروع سكني</option>
                    <option value="commercial">مشروع تجاري</option>
                    <option value="other">أخرى</option>
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    وصف المشروع <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="projectDescription"
                    value={formData.projectDescription}
                    onChange={handleChange}
                    required
                    rows={6}
                    maxLength={500}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1] resize-none"
                    placeholder="اشرح تفاصيل مشروعك ومتطلباتك..."
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1">
                    {formData.projectDescription.length}/500 حرف
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">الميزانية التقريبية</label>
                    <select
                      name="budget"
                      value={formData.budget}
                      onChange={handleChange}
                      className="w-full px-4 py-3 pr-8 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1] cursor-pointer"
                    >
                      <option value="">اختر الميزانية</option>
                      <option value="50k">أقل من 50,000 ريال</option>
                      <option value="100k">50,000 - 100,000 ريال</option>
                      <option value="250k">100,000 - 250,000 ريال</option>
                      <option value="500k">250,000 - 500,000 ريال</option>
                      <option value="1m">500,000 - 1,000,000 ريال</option>
                      <option value="more">أكثر من 1,000,000 ريال</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-gray-700 font-medium mb-2">الإطار الزمني</label>
                    <select
                      name="timeline"
                      value={formData.timeline}
                      onChange={handleChange}
                      className="w-full px-4 py-3 pr-8 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0D47A1] cursor-pointer"
                    >
                      <option value="">اختر الإطار الزمني</option>
                      <option value="urgent">عاجل (أقل من شهر)</option>
                      <option value="1-3">1-3 أشهر</option>
                      <option value="3-6">3-6 أشهر</option>
                      <option value="6+">أكثر من 6 أشهر</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-2">
                    إرفاق ملفات (اختياري)
                  </label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#0D47A1] transition-colors">
                    <input
                      type="file"
                      multiple
                      onChange={handleFileChange}
                      className="hidden"
                      id="file-upload"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    <label htmlFor="file-upload" className="cursor-pointer">
                      <i className="ri-upload-cloud-2-line text-5xl text-gray-400 mb-3 block"></i>
                      <p className="text-gray-600 mb-2">اسحب الملفات هنا أو انقر للتحميل</p>
                      <p className="text-sm text-gray-500">PDF, DOC, JPG, PNG (حتى 10MB)</p>
                    </label>
                  </div>
                  {files.length > 0 && (
                    <div className="mt-4 space-y-2">
                      {files.map((file, index) => (
                        <div key={index} className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
                          <i className="ri-file-line text-[#0D47A1]"></i>
                          <span className="text-sm text-gray-700 flex-1">{file.name}</span>
                          <span className="text-xs text-gray-500">{(file.size / 1024).toFixed(1)} KB</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#0D47A1] text-white py-4 rounded-lg font-bold text-lg hover:bg-[#0a3a8a] transition-colors disabled:bg-gray-400 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    <>
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      جاري الإرسال...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-fill"></i>
                      إرسال الطلب
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>

          {/* Info Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">لماذا متجر العمران؟</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-[#0D47A1]"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">خبرة 15+ سنة</h4>
                    <p className="text-sm text-gray-600">في تنفيذ المشاريع الكبرى</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-team-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">فريق محترف</h4>
                    <p className="text-sm text-gray-600">مهندسون وفنيون معتمدون</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-orange-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-price-tag-3-line text-[#FF8F00]"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">أسعار تنافسية</h4>
                    <p className="text-sm text-gray-600">أفضل قيمة مقابل المال</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-purple-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-purple-600"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800 mb-1">دعم مستمر</h4>
                    <p className="text-sm text-gray-600">خدمة ما بعد البيع والصيانة</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#0D47A1] to-[#1976D2] rounded-2xl shadow-lg p-6 text-white">
              <h3 className="text-xl font-bold mb-4">تواصل معنا مباشرة</h3>
              <div className="space-y-3">
                <a href="tel:+966500000000" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
                  <i className="ri-phone-line text-xl"></i>
                  <span>+966 50 000 0000</span>
                </a>
                <a href="mailto:info@omran.sa" className="flex items-center gap-3 hover:opacity-80 transition-opacity cursor-pointer">
                  <i className="ri-mail-line text-xl"></i>
                  <span>info@omran.sa</span>
                </a>
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-xl mt-1"></i>
                  <span>الرياض، المملكة العربية السعودية</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default QuoteRequestPage;